import { render, staticRenderFns } from "./AdminNotifications.vue?vue&type=template&id=3efb9e38"
import script from "./AdminNotifications.vue?vue&type=script&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efb9e38')) {
      api.createRecord('3efb9e38', component.options)
    } else {
      api.reload('3efb9e38', component.options)
    }
    module.hot.accept("./AdminNotifications.vue?vue&type=template&id=3efb9e38", function () {
      api.rerender('3efb9e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admins/AdminNotifications.vue"
export default component.exports